import { render, staticRenderFns } from "./PedidoRepartoProjectTableComponent.vue?vue&type=template&id=13c359e8&"
import script from "./PedidoRepartoProjectTableComponent.vue?vue&type=script&lang=js&"
export * from "./PedidoRepartoProjectTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports